var map = {
	"./IMG-20251011-WA0000.jpg": 193,
	"./image1.jpg": 3116,
	"./image2.jpg": 5099,
	"./image3.jpg": 7054,
	"./image4.jpg": 9525,
	"./image5.jpg": 1656,
	"./image6.jpg": 9111,
	"./image7.jpg": 893,
	"./image8.jpg": 4385,
	"./image9.jpg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9191;